// export var cmc3_api_gateway = 'https://apigw.f5traders.com/cmc3'
export var cmc3_api_gateway = 'https://apigw.f5traders.com/cmc'
export var lv3_api_gateway = 'https://apigw.f5traders.com/lv3' 
export var authen_url = 'https://authen.f5traders.com'